export const newspaperFiltersInitialState = {
  // subjectFilter: {
  //   hasFilter: false,
  //   isOpen: false,
  //   selectedIds: [],
  //   componentName: 'subjectFilter',
  //   translateKey: 'filter:subject',
  // },
  languageFilter: {
    hasFilter: false,
    isOpen: false,
    selectedValue: 'all',
    componentName: 'languageFilter',
    translateKey: 'filter:language',
  },
  resourceCategoryFilter: {
    hasFilter: false,
    isOpen: false,
    selectedValue: '',
    platform: 'newspaper',
    componentName: 'resourceCategoryFilter',
    translateKey: 'filter:resourceCategory',
    hasIncludeExclude: false,
    filterType: 'include',
  },
  resourcesFilter: {
    hasFilter: false,
    isOpen: false,
    selectedValue: 'include',
    selectedItems: {},
    hasIncludeExclude: false,
    platform: 'newspaper',
    componentName: 'resourcesFilter',
    translateKey: 'filter:resourceSearch',
  },
};
